// extracted by mini-css-extract-plugin
module.exports = {"main":"bP_t","container":"bP_bd","icon":"bP_j","title":"bP_f","separatorText":"bP_b2","resetButton":"bP_fx","tagEmail":"bP_fy"};